<template>
    <div class="login-container" :style="isWindow?'height:424px;width:860px;':''">
        <div class="content">
            <img class="logo" v-if="!isWindow" src="../assets/images/logoBlack.png" alt="">
            <div class="info" :style="isWindow?'height:424px;width:860px;padding:0;margin-top:0':''">
                <div class="right">
                    <div class="top">
                        <!-- <span @click="changeLoginType('pass')" :class="isPassLogin ? 'top-active' : ''">密码登录</span>
                        <span style="margin:0 15px">|</span> -->
                        <span @click="changeLoginType('code')">短信登录</span>
                    </div>
                    <div class="middle">
                        <el-form ref="loginForm" :rules="rules" :model="dataForm">
                            <el-form-item prop="phone">
                                <!-- <div class="passLogin" v-if="isPassLogin">
                                    <el-input v-model="phone" :class="phone == '' ? 'null-input' : 'no-null-input'" placeholder="请输入手机号或身份证号"/>
                                    <el-input style="margin-top:25px;" v-model="password" :class="password == '' ? 'null-input' : 'no-null-input'" placeholder="密码" />
                                </div> -->
                                <el-input v-model="dataForm.phone" :class="dataForm.phone == '' ? 'null-input' : 'no-null-input'" maxlength="11" placeholder="请输入手机号"/>
                            </el-form-item>
                            <el-form-item prop="phoneCode">
                                <div class="codeLogin" v-if="!isPassLogin" >
                                    <el-input
                                        id="txtValidCode"
                                        placeholder="请输入验证码"
                                        clearable
                                        v-model="dataForm.phoneCode"
                                        maxlength="6"
                                        class="null-input">
                                        <span
                                            v-show="show"
                                            class="slot"
                                            slot="suffix"
                                            @click="queryValiCode"
                                            >发送验证码
                                        </span>
                                        <span v-show="!show" class="slot" slot="suffix"
                                            >已发送{{ count }}s</span>
                                        </el-input>
                                </div>
                            </el-form-item>
                        </el-form>
                        <ComRange style="margin-top:25px;"
                            :status="dataForm.status"
                            :successFun="onMpanelSuccess"
                            :errorFun="onMpanelError"
                        ></ComRange>
                    </div>
                    <el-button class="btnLogin" @click="login">登录</el-button>
                    <!-- <div class="bottom">
                        <span>忘记密码?</span>
                        <span style="margin:0 15px">|</span>
                        <span>免费注册</span>
                    </div> -->
                </div>
                <div style="width:1px;height:90%;border-right:1px solid #EDEEEF;margin-left:61px"></div>
                <div class="left">
                    <div style="padding-right:5px">其他方式登录</div>
                    <img class="qrcode"  :src="qrCodeUrl" alt="">
                    <div class="tootip">请使用微信扫码二维码登录</div>
                    <div class="bottom">
                        <div class="hLine"></div>
                        <span>合作账号登录</span>
                        <div class="hLine"></div>
                    </div>
                    <div @click="qqLoginClick('qq')">
                        <img class="img" src="../assets/icons/03_qq_symbol-1-250x300.png"  alt="">
                        <div class="qqIcon"
                       
                        id="qqLoginBtn"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import ComRange from "../components/ComRange.vue";
import { login,getQrcode,getUUID,queryUserIsLogin,loginOperation } from "@/comm/login"
import { getAction, deleteAction, putAction, postAction, httpAction } from '@/comm/manage'
import Vue from 'vue'

export default {
    name: "Login",
    components: {
        ComRange,
    },
    props:{
        isWindow:{
            type:Boolean,
            default:false
        },
    },
    data() {
        let checkPhone = (rule, value, callback) => {
            var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
            if (value === '') {
                callback(new Error('请输入手机号'))
            } else if (!myreg.test(value)) {
                callback(new Error('请输入有效的手机号码'))
            } else {
                callback()
            }
        }
        return {
            dataForm: {
                phone: '',
                phoneCode:'',
                status: ''
            },
            qrCodeUrl:'',
            password: '',
            curUUID: '',
            ticket:'',
            isPassLogin: false,
            isMpanelSuccess: false,
            show: true,
            timer: null,
            count: 0,
            rules: {
                phone: [{ validator: checkPhone, trigger: 'blur' }],
                phoneCode: [{ required: true, message: "请输入短信验证码", trigger: "blur" }],
            },
            checkTimer:null,
        }
    },
    mounted() {
        // 为每个用户分配一个场景ID
        getUUID().then(res => {
            this.curUUID = res.message;
            getQrcode({sceneId: this.curUUID}).then(res => {
               
                this.ticket = res.result.ticket;
                this.qrCodeUrl = res.result.ticketUrl;
            }).catch(e => {})
            this.checkTimer = setInterval(this.queryUserIsLogin,2000);
        })
    },
    destroyed() {
        clearInterval(this.checkTimer);
    },
    methods: {
        qqLoginClick (value) {
            // 直接弹出授权页面，授权过后跳转到回调页面进行登录处理
            // QC.Login.showPopup({
            //     appId: '101991802',
            //     redirectURI: 'http://127.0.0.1:443/jeecg-boot/qq/callback'
            // })
             
             getAction("/qq/oauth").then((res) => {
                
                    if (res.success) {
                    var width = width || 900;
                    var height = height || 540;
                	var left = (window.screen.width - width) / 2;
                	var top = (window.screen.height - height) / 2;
                	var win =window.open(res.message, "_blank",
                		"toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, left=" +
                		left + ", top=" + top + ", width=" + width + ", height=" + height);
                    //监听登录窗口是否关闭,登录成功后 后端返回关闭窗口的代码
                    const _this = this;
                    var listener=setInterval(function(){
                        //监听窗口是否关闭
                        if(win.closed){
                            //进入这个if代表后端验证成功!直接跳转路由
                            clearInterval(listener);//关闭监听
                            // //跳转路由
                            // var path = this.$route.query.redirect;
                            // this.$router.replace({
                            // path:
                            //     path === "/" || path === undefined ? "/" : "/"
                            // });
                            // this.$router.go(0) //刷新
                            // JSON.parse(localStorage.getItem('qqlogin'));
                            var res = JSON.parse(localStorage.getItem('qqlogin'));
                            _this.$store.dispatch("setUserInfo",res.result.userInfo);
                            loginOperation(res);
                            localStorage.removeItem('qqlogin');
                            _this.loginAfterRouterCon();
                        }
                        },500)
                    } 
                });
//             window.open("/logincheck","TencentLogin",
//    "width=450,height=320,menubar=0,scrollbars=1,resizable=1,status=1,titlebar=0,toolbar=0,location=1");

        },
        onMpanelSuccess() {
            this.isMpanelSuccess = true;
        },
        onMpanelError() {
            this.isMpanelSuccess = false;
        },
        send() {
            const TIME_COUNT = 300; //更改倒计时时间
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                } else {
                    this.show = true;
                    clearInterval(this.timer); // 清除定时器
                    this.timer = null;
                }
                }, 3000);
                
                var data={"phone":this.dataForm.phone,"type":"1"};
                getAction("/thepoly/sendLoginCode", data).then((res) => {
                    if (res.success) {
                    
                    } 
                });
                       
            }
        },
        changeLoginType(type) {
            this.isPassLogin = type === 'pass' ? true : false;
        },
        queryValiCode() {
            this.send()
        },
        loginAfterRouterCon(){
            
            if(this.isWindow){//页面内登录
                this.$emit('loginAfter');//通知父级页面继续其他操作
            }else{
                const currPath = Vue.ls.get("preRoute");
                const { href } = this.$router.resolve({
                                path: !currPath?'/personalHome':currPath,
                                query: { id: 'personalHome' },
                            });
                window.open(href, "_self");
            }
        },
        login() {
            this.$refs['loginForm'].validate((valid) => {
                if(valid) {
                    if(!this.isMpanelSuccess) {
                        this.$message('请先完成滑块验证');
                        return;
                    }
                    login(this.dataForm).then(res => {
                        if(res.success) {
                            
                            var data={"personId":res.result.userInfo.id,"pointType":"1426822873705496578","sourceId":null};
                            postAction("/person/thepolyPersonPoint/add", data).then((res) => {
                                if (res.success) {
                                
                                } 
                            });
                            // 登录成功，跳转到个人中心
                            this.$store.dispatch("setUserInfo",res.result.userInfo);
                            this.loginAfterRouterCon();
                        }
                    }).catch(e => {
                        this.$message.error(e)
                    })
                }
            })
        },
        queryUserIsLogin() {
            let params={type:"check",uuid:this.ticket};
            queryUserIsLogin(params).then(res => {
                clearInterval(this.checkTimer);
                // 登录成功，跳转到个人中心
                
               this.$store.dispatch("setUserInfo",res.result.userInfo);
               this.loginAfterRouterCon();
            }).catch(e => {
                // console.log(e);
            })
        }
    }
}
</script>
<style lang="stylus" scoped>
    .null-input .el-input__inner {
        background-color: #EDEEEF !important;
        border none;
        height 44px;
        margin-bottom 20px;
    }
    .no-null-input .el-input__inner {
        background-color: #fff !important;
        // border none;
        height 44px;
        margin-bottom 20px;
    }
    .slot {
        color: #f82b17;
        font-size: 12px;
        margin: 20px 5px 0 5px;
        line-height: 44px;
        cursor: pointer;
    }
</style>
<style lang="stylus" scoped>
    .login-container {
        width 100%;
        height 100vh;
        background #F3F3F5;
        display flex;
        align-items center;
        .content {
            margin 0 auto;
            .logo {
                // width 169px;
                // height 34px;
            }
            .info {
                margin-top 29px;
                width: 900px;
                height: 424px;
                background: #FFFFFF;
                border-radius: 4px;
                padding 43px 62px;
                display flex;

                .right {
                    width: 50%;
                    .top {
                        font-size: 16px;
                        // color: #F62C16;
                        color: #5B5C5D;
                        line-height: 21px;
                        cursor: pointer;
                    }
                    .top-active {
                        color: #F62C16;
                    }
                    .middle {
                        margin-top 25px;
                        .int {
                            margin-bottom 20px;
                            // background #F3F4F5;
                        }
                        >>> .el-input__inner {
                            -webkit-appearance: none;
                            background-color: #EDEEEF;
                            background-image: none;
                            border-radius: 4px;
                            border: 1px solid #d6d8d9;
                            box-sizing: border-box;
                            color: #606266;
                            display: inline-block;
                            font-size: inherit;
                            height: 45px;
                            line-height: 45px;
                            outline: 0;
                            padding: 0 15px;
                            transition: border-color .2s cubic-bezier(.645,.045,.355,1);
                            width: 100%;
                        }
                    }
                    .bottom {
                        display flex;
                        justify-content flex-end;
                        margin-top 20px;
                        font-size: 14px;
                        color: #BABBBC;
                        line-height: 19px;
                        cursor: pointer;
                        span:hover {
                            color: #F62C16;
                        }
                    }
                    .btnLogin {
                        margin-top 20px;
                        background: #080723;
                        border-radius: 4px;
                        width 100%;
                        font-size: 14px;
                        color: #FFFFFF;
                        line-height: 19px;
                    }
                }
                .left {
                    width: 50%;
                    text-align center;
                    .top {
                        font-size: 16px;
                        color: #313131;
                        line-height: 21px;
                    }
                    .qrcode {
                        width 148px;
                        height 148px;
                        // margin-top 48px;
                    }
                    .tootip {
                        font-size: 14px;
                        color: #313131;
                        line-height: 19px;
                        margin-top 18px;
                    }
                    .bottom {
                        display flex;
                        justify-content center;
                        align-items center;
                        font-size: 12px;
                        color: #636465;
                        line-height: 16px;
                        margin-top 20px;
                        .hLine {
                            border-top:1px solid #EDEEEF;
                            width:105px;
                            height:1px;
                            margin 0px 6px;
                        }
                    }
                    .img {
                        cursor pointer;
                        // border-radius:50px;
                        margin-top:20px;
                        width: 50px;
                        height:50px;
                    }
                }

            }
        }
    }
</style> 